export enum DisciplineSubmissionDeadlineType {
  DONE = 'DONE',
  PENDING = 'PENDING',
}

export interface DisciplineSubmissionDeadline {
  id: string;
  type: DisciplineSubmissionDeadlineType;
  dueDate: Date;
  discipline: { id: string; name: string };
  stage: number;
}
